const deliveryDate = '2022-10-08T00:00:00Z';

export const mockProductReferenceWithDelivery = [
  {
    brandId: 'puma',
    productId: '520116-05',
    deliveryInfo: [
      {
        productSizeId: '520116-05-INT128',
        orderType: 'FUTURE',
        quantity: 1,
        deliveryDate,
      },
      {
        productSizeId: '520116-05-INT140',
        orderType: 'FUTURE',
        quantity: 1,
        deliveryDate,
      },
    ],
  },
  {
    brandId: 'puma',
    productId: '595850-05',
    deliveryInfo: [
      {
        productSizeId: '595850-05-INT128',
        orderType: 'FUTURE',
        quantity: 1,
        deliveryDate,
      },
      {
        productSizeId: '595850-05-INT140',
        orderType: 'FUTURE',
        quantity: 1,
        deliveryDate,
      },
    ],
  },
];

export const mockProductReferenceWithoutDelivery =
  mockProductReferenceWithDelivery.map(({ brandId, productId }) => ({
    brandId,
    productId,
    deliveryInfo: undefined,
  }));
